import gql from 'graphql-tag';

export default gql`
    mutation ResolveDriverLoadNote($input: ResolveDriverLoadNoteInput) {
        resolveDriverLoadNote(input: $input) {
            errors
        }
    }
`;
